module.exports = __webpack_public_path__ + "img/56.5a32c404.jpg";